<dx-scroll-view height="100%" width="100%" class="with-footer single-card">
  <div class="content-block dx-card responsive-paddings">
    @if (!clock.manual) {
    <div>Data e Ora: <b>{{clock.gpsDate | date:'dd/MM/yyyy HH:mm:ss'}}</b></div>
    }
    @if (clock.manual) {
    <div>Data e Ora manuale: <b>{{clock.deviceDate | date:'dd/MM/yyyy HH:mm:ss'}}</b></div>
    }
    <div>Cantiere : <b>{{clock.descrizioneCantiere}}</b></div>
    @if (clock.descrizioneFase) {
    <div>Fase : <b>{{clock.descrizioneFase}}</b></div>
    }
    <div>Precisione : <b>{{clock.precision}}</b> Metri</div>
    <div>Distanza da cantiere : <b>{{clock.distanzaCantiereInMetri | number : '1.0-0' }}</b></div>
  </div>
  @if (!clock.manual) {
  <!--
    <div>
      <dx-map #map
        center="41.890262, 12.49175"
        [zoom]="18"
        [height]="500"
        width="100%"
        provider="azure"
        [apiKey]="apiKey"
        [controls]="true"
        type="hybrid"
        [markers]="markers">
      </dx-map>
    </div>
    -->

  <div class="map-page-container">
    <div id="ol-map" class="map"></div>

    <!-- Popup -->
    <div id="popup" class="ol-popup">
      <a href="#" id="popup-closer" class="ol-popup-closer">×</a>
      <div id="popup-content"></div>
    </div>
  </div>

  }
</dx-scroll-view>
